import type { InjectionKey, Ref } from 'vue'

// App owns the authenticated player-session snapshot. Public views consume
// this fail-closed signal only to reveal moderator presentation details; it is
// not an authorization boundary and must not replace server-side role checks.
export const playerModeratorKey: InjectionKey<Readonly<Ref<boolean>>> = Symbol(
  'player-moderator',
)
